// React Query hooks for the F-C admin asset surface.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Asset, getStaffAsset, purgeAsset } from "../assets";

export const assetKeys = {
  all: ["assets"] as const,
  detail: (id: string) => [...assetKeys.all, "detail", id] as const,
};

export function useStaffAsset(assetId: string | undefined) {
  return useQuery<Asset>({
    queryKey: assetKeys.detail(assetId ?? ""),
    queryFn: () => getStaffAsset(assetId as string),
    enabled: Boolean(assetId),
  });
}

export function usePurgeAsset() {
  const qc = useQueryClient();
  return useMutation<Asset, Error, { assetId: string; reason: string }>({
    mutationFn: ({ assetId, reason }) => purgeAsset(assetId, reason),
    onSuccess: (asset) => {
      qc.setQueryData(assetKeys.detail(asset.id), asset);
    },
  });
}
